import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { QUERY_PARAMS } from "@av/apps/recruitment/ats-common/routes/jobs/query-params";
import { isSupportedLocale } from "@av/components/organisms/editor/localized-text-editor/text-editor-supported-locales";
import { useLocaleStore } from "@av/utils/hooks/useLocaleStore";

export function useLocaleSearchParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { locale, setLocale } = useLocaleStore();
  const urlLocaleParam = searchParams.get(QUERY_PARAMS.locale);
  const localeSearchParam =
    urlLocaleParam && isSupportedLocale(urlLocaleParam) ? urlLocaleParam : locale;

  useEffect(() => {
    if (localeSearchParam !== locale) {
      setLocale(localeSearchParam);
    }

    if (urlLocaleParam !== localeSearchParam) {
      setSearchParams(
        (currentSearchParams) => {
          const nextSearchParams = new URLSearchParams(currentSearchParams);

          nextSearchParams.set(QUERY_PARAMS.locale, localeSearchParam);
          nextSearchParams.sort();

          return nextSearchParams;
        },
        // Keep the job board's record of where this entry came from. It may have been set by an
        // earlier effect in this commit, so it is read from the history entry, not from the render.
        { replace: true, state: window.history.state?.usr }
      );
    }
  }, [locale, localeSearchParam, setLocale, setSearchParams, urlLocaleParam]);
}
